import { render, staticRenderFns } from "./databaze.vue?vue&type=template&id=418f81c4&scoped=true&"
import script from "./databaze.vue?vue&type=script&lang=js&"
export * from "./databaze.vue?vue&type=script&lang=js&"
import style0 from "./databaze.vue?vue&type=style&index=0&id=418f81c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f81c4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ItemBox: require('/opt/buildhome/repo/components/item-box.vue').default})
